import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-history-item-small',
  templateUrl: './history-item-small.component.html',
  styles: []
})
export class HistoryItemSmallComponent extends ExcTranslation implements OnInit {

  @Input('data') data;
  constructor() {
    super();
  }

  getAvatarClass() {
    return this.data.HistoryAuditType === 16
      ? 'fa-mobile th-secondary'
      : 'fa-user-secret th-secondary';
  }
  /*getAvatarClass() {
    if (this.data.AuditType === 16) {
      if (this.data.AuditIsPicked) {
        return 'fa-mobile th-warning';
      } else {
      return 'fa-mobile th-secondary';
      }
    } else {
      if (this.data.AuditIsPicked) {
        return 'fa-user-secret th-warning';
      } else {
        return 'fa-user-secret th-secondary';
      }
    }
  }
  getAttractorTip() {
    if (this.data.AuditType === 16) {
      switch (this.data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
          break;
        case 8:
        case 9:
          if (this.data.ScRejected === true) {
            return this.getGlobal('Rejected');
          } else {
            if (this.data.ScEnded === true) {
              return this.getGlobal('Done');
            } else {
              return this.getGlobal('Expired');
            }
          }
          break;
        case 10:
          return this.getGlobal('Cancelled');
          break;
      }
    } else {
      switch (this.data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
          break;
        case 4:
        case 5:
        case 6:
        case 7:
          return this.getGlobal('InProgress');
          break;
        case 8:
        case 9:
          return this.getGlobal('Done');
          break;
        case 10:
          return this.getGlobal('Cancelled');
          break;
      }
    }
  }
  getAttractorClass() {
    if (this.data.AuditType === 16) {
      switch (this.data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
          break;
        case 8:
        case 9:
          if (this.data.ScRejected === true) {
            return 'ch-danger fa-exclamation';
          } else {
            if (this.data.ScEnded === true) {
              return 'ch-success fa-check';
            } else {
              return 'ch-warning fa-clock';
            }
          }
          break;
        case 10:
          return 'ch-warning fa-ban';
          break;
      }
    } else {
      switch (this.data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
          break;
        case 4:
        case 5:
        case 6:
        case 7:
          return 'ch-secondary fa-cogs';
          break;
        case 8:
        case 9:
          return 'ch-success fa-check';
          break;
        case 10:
          return 'ch-warning fa-ban';
          break;
      }
    }
  }*/

  ngOnInit() {
  }

}
